import Component from '@glimmer/component';
import can from 'ember-can/helpers/can';
import cannot from 'ember-can/helpers/cannot';
import link from 'ember-link/helpers/link';
import RouteTemplate from 'ember-route-template';
import QuestionnaireForm from 'garaje/components/visitors/questionnaires/form';
import LOCALES, { type Locale } from 'garaje/utils/locale-options';

import type { VisitorsQuestionnairesShowRouteModel } from './route';

interface VisitorsQuestionnairesShowRouteTemplateSignature {
  Args: {
    model: VisitorsQuestionnairesShowRouteModel;
  };
}

class VisitorsQuestionnairesShowRouteTemplate extends Component<VisitorsQuestionnairesShowRouteTemplateSignature> {
  get availableLocales(): Locale[] {
    const location = this.args.model.location;
    const defaultLocale = LOCALES.find((locale) => locale.value === location.locale);
    if (!defaultLocale) return [];

    const additionalLocales: Locale[] = [];
    if (location.multipleLanguagesEnabled) {
      for (const localeKey of location.enabledLocales) {
        const locale = LOCALES.find((locale) => locale.value === localeKey);
        if (locale) additionalLocales.push(locale);
      }
    }
    return [defaultLocale, ...additionalLocales.toSorted((a, b) => a.label.localeCompare(b.label))];
  }

  <template>
    {{#let (link route="visitors.questionnaires") as |indexRouteLink|}}
      <QuestionnaireForm
        @availableLocales={{this.availableLocales}}
        @backLink={{indexRouteLink}}
        @canDeleteQuestionnaires={{can "delete questionnaires"}}
        @changedModels={{@model.changes}}
        @defaultLocale={{@model.location.locale}}
        @fetchFlowsPage={{@model.fetchFlowsPage}}
        @flows={{@model.flows}}
        @questionnaire={{@model.questionnaire}}
        @onSave={{indexRouteLink.transitionTo}}
        @readOnly={{cannot "update questionnaires"}}
      />
    {{/let}}
  </template>
}

export default RouteTemplate(VisitorsQuestionnairesShowRouteTemplate);
